import React from 'react';
import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { NEIGHBOURHOOD_TOOLTIP_Z_INDEX } from 'src/const';

const aspectRatio = 1.75;

export const ZoomButtons = ({
  size,
  setZoom,
  zoomInAction,
  zoomOutFunction,
}: {
  size: number;
  setZoom: React.Dispatch<React.SetStateAction<number>>;
  zoomInAction?: () => void;
  zoomOutFunction?: () => void;
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down(900));
  return (
    <Box
      sx={{
        width: `${size}px`,
        height: `${size * aspectRatio}px`,
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        pointerEvents: 'auto',
        borderRadius: '4px',
        boxShadow: '0 2px 6px #0005',
      }}
    >
      <Button
        onClick={() => {
          setZoom(prevZoom => prevZoom + 1);
          zoomInAction && zoomInAction();
        }}
        sx={{ height: '50%', width: `${size}px`, minWidth: '0px', borderBottom: '2px solid #eee' }}
      >
        <AddIcon
          sx={{ fontSize: `${size / 2}px`, fontWeight: '800', color: '#555', stroke: '#555' }}
        />
      </Button>
      <Button
        onClick={() => {
          setZoom(prevZoom => prevZoom - 1);
          zoomOutFunction && zoomOutFunction();
        }}
        sx={{ height: '50%', width: `${size}px`, minWidth: '0px' }}
      >
        <RemoveIcon
          sx={{ fontSize: `${size / 2}px`, fontWeight: '800', color: '#555', stroke: '#555' }}
        />
      </Button>
    </Box>
  );
};
